import { FC, useMemo } from "react";
import { Box } from "@mui/material";
import { AxisLabelsFormatterContextObject } from "highcharts";
import { useAppSelector } from "@/store/hooks";
import { resourceDetailsCoverageChartTypeSelector } from "@/store/resource-details/selectors/coverage-data/options/resourceDetailsCoverageChartTypeSelector";
import { HighchartsProvider } from "@/storybook/c8r-highcharts/common/components/HighchartsProvider";
import { MultiTypeHighcharts } from "@/storybook/c8r-highcharts/MultiTypeHighcharts";
import { stackedChartHeadingLabelFormatter } from "@/storybook/c8r-highcharts/common/utils/helpers/stackedChartHeadingLabelFormatter";
import { resourceDetailsResourceCoverageDataLoadingSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageDataLoadingSelector";
import { resourceDetailsResourceCoverageChartDataSelector } from "@/store/resource-details/selectors/coverage-data/resourceDetailsResourceCoverageChartDataSelector";
import { TooltipMarkupGenerator } from "@/storybook/c8r-highcharts/common/utils/types/common";
import { resourceDetailsCoverageChartTooltipOptions } from "@/components/pages/common/resource-details/components/content/coverage-content/components/chart/utils/resourceDetailsCoverageChartTooltipOptions";
import { getResourceDetailsCoverageChartTooltipValueFormatter } from "@/components/pages/common/resource-details/components/content/coverage-content/components/chart/utils/getResourceDetailsCoverageChartTooltipValueFormatter";

export const ResourceDetailsCoverageTabChart: FC = () => {
  const chartType = useAppSelector(resourceDetailsCoverageChartTypeSelector);
  const chartData = useAppSelector(
    resourceDetailsResourceCoverageChartDataSelector,
  );
  const loading = useAppSelector(
    resourceDetailsResourceCoverageDataLoadingSelector,
  );

  const tooltipValueFormatter: TooltipMarkupGenerator = useMemo(
    () => getResourceDetailsCoverageChartTooltipValueFormatter(chartData),
    [chartData],
  );

  if (!chartType) {
    return null;
  }

  return (
    <Box height={200}>
      <HighchartsProvider>
        <MultiTypeHighcharts
          showLegends
          percentBased
          maxHeight={200}
          chartData={chartData}
          chartType={chartType}
          areaChartStacking="normal"
          loading={loading ? loadingProps : false}
          yAxisLabelsFormatter={yAxisLabelsFormatter}
          tooltipMarkupGenerator={tooltipValueFormatter}
          tooltipOptions={resourceDetailsCoverageChartTooltipOptions}
          noDataMessage="No data by your selected date range and filters."
          stackedChartHeadingLabelFormatter={stackedChartHeadingLabelFormatter}
        />
      </HighchartsProvider>
    </Box>
  );
};

const yAxisLabelsFormatter = (params: AxisLabelsFormatterContextObject) =>
  `${params.value}%`;

const loadingProps = { showLoader: true };
